module.exports = __webpack_public_path__ + "static/media/emp_sample.1f93090e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/emp_sample.JPG
// module id = 1450
// module chunks = 1